export default __webpack_public_path__ + "static/media/cake-pop.8333b713.jpg";